/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisabledIntegration
 */
export interface DisabledIntegration {
    /**
     * The type of integration that is disabled
     * @type {string}
     * @memberof DisabledIntegration
     */
    integration_type: string;
    /**
     * The scope of the disabled integration (global, organization, or organization:facility)
     * @type {string}
     * @memberof DisabledIntegration
     */
    org_fac_key: string;
    /**
     * User ID who disabled the integration
     * @type {string}
     * @memberof DisabledIntegration
     */
    disabled_by: string;
    /**
     * Unix timestamp when the integration was disabled
     * @type {number}
     * @memberof DisabledIntegration
     */
    disabled_at: number;
    /**
     * Unix timestamp when the integration should be automatically re-enabled (optional)
     * @type {number}
     * @memberof DisabledIntegration
     */
    reenable_time?: number;
    /**
     * Why the integration was disabled (e.g., "SITE_VERIFICATION", "ACCOUNT_LOCKED", "INTEGRATION_IS_DOWN", "OTHER")
     * @type {string}
     * @memberof DisabledIntegration
     */
    reason?: string;
}

/**
 * Check if a given object implements the DisabledIntegration interface.
 */
export function instanceOfDisabledIntegration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "integration_type" in value;
    isInstance = isInstance && "org_fac_key" in value;
    isInstance = isInstance && "disabled_by" in value;
    isInstance = isInstance && "disabled_at" in value;

    return isInstance;
}

export function DisabledIntegrationFromJSON(json: any): DisabledIntegration {
    return DisabledIntegrationFromJSONTyped(json, false);
}

export function DisabledIntegrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisabledIntegration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'integration_type': json['integration_type'],
        'org_fac_key': json['org_fac_key'],
        'disabled_by': json['disabled_by'],
        'disabled_at': json['disabled_at'],
        'reenable_time': !exists(json, 'reenable_time') ? undefined : json['reenable_time'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function DisabledIntegrationToJSON(value?: DisabledIntegration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'integration_type': value.integration_type,
        'org_fac_key': value.org_fac_key,
        'disabled_by': value.disabled_by,
        'disabled_at': value.disabled_at,
        'reenable_time': value.reenable_time,
        'reason': value.reason,
    };
}

